import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";

import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useMicrorregiao = ({ formikRef, microrregioesDisponiveis, salvarLocalStorage, chave  }) => {
  const [microrregioes, setMicrorregioes] = useState([]);
  const microrregiaoSelect = useSelect("microrregiao");
  const [microrregiao, setMicrorregiao] = useState(0);
  const [fila, setFila] = useState(null);
  const [onMicrorregiao, setOnMicrorregiao] = useState(false)

  useEffect(() => {
    const fetchMicrorregioes = async (signal) => {
      let query = db.microrregiao;

      if (microrregioesDisponiveis) {
        query = query.where('id').anyOf(microrregioesDisponiveis);
      }
      const result = [];
      await query.each((item) => result.push(item));

      if (!signal.aborted) {
        setMicrorregioes(result);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchMicrorregioes(signal);
    return () => {
      // Cancela a execução pendente ao desmontar ou ao reexecutar o efeito
      controller.abort();
    };
  }, [microrregioesDisponiveis]);


  const optionMicrorregioes = useMemo(() => prepareForOptions((microrregioes || []).sort((a, b) => a.nome.localeCompare(b.nome)), ['nome'], 'id'), [microrregioes]);

  useEffect(() => {
    if (fila && optionMicrorregioes?.length > 0) {
      SetSelectMicrorregiao(fila);
    }
  }, [fila, optionMicrorregioes])

  function onChangeMicrorregiao(e) {
    setOnMicrorregiao(e.value > 0)
    microrregiaoSelect.upDateValue(e.value);
    microrregiaoSelect.upDateDefaultValue(e || "");
    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    if (formikRef?.current) {
      formikRef.current.setFieldValue("microrregiaoId", e.value);
      setTimeout(() => formikRef.current.setFieldTouched("microrregiaoId", true));
    }
    setMicrorregiao(e.value);
  }

  function CleanForFilter(option) {
    onChangeMicrorregiao(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  function SetSelectMicrorregiao(id) {
    if (optionMicrorregioes?.length > 0) {
      const filial = optionMicrorregioes.find((micro) => micro.value === id);
      if (filial)
        onChangeMicrorregiao(filial);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if(salvarLocalStorage){
      const microSalva = localStorage.getItem(chave);

    if (microSalva) {
      const microObj = JSON.parse(microSalva);

      SetSelectMicrorregiao(microObj.value);
      onChangeMicrorregiao(microObj);
      setMicrorregiao(microObj.value);
    }
    }
  }, [])

  return {
    microrregioes,
    optionMicrorregioes,
    onChangeMicrorregiao,
    SetSelectMicrorregiao,
    microrregiao,
    onMicrorregiao,
    microrregiaoSelect,
    CleanForFilter
  }
}

export default useMicrorregiao;